var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.000976562H513V341.992H0V-0.000976562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.000976562H513V113.996H0V-0.000976562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 227.995H513V341.992H0V227.995Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 171L0 341.996V-0.00878906L256.5 171Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0652 139.734L85.9566 156.236L103.777 152.118L95.7968 168.576L110.128 179.941L92.2849 183.963L92.334 202.253L78.0652 190.81L63.7964 202.253L63.8465 183.963L46.0027 179.941L60.3336 168.576L52.3531 152.118L70.1738 156.236L78.0652 139.734Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00683594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJo);
export default __webpack_public_path__ + "static/media/JO.9373a1c2d07b30f1c6de341ba05499bc.svg";
export { ForwardRef as ReactComponent };